<template>
  <div class="card_content item-content"
       :class="[classCardContent, contexto === 'item' ? 'card_content-seguirleiloeiro' : '', { destaque: isDestaque }]">
    <div class="card_content-header" :class="contexto === 'item' ? 'card_content-header-seguirleiloeiro' : ''">
      <div v-if="contexto === 'item' && isTablet">
        <CustomCarousel
          v-if="dados.fotos && dados.fotos.length > 0"
          :contexto="contexto"
          :paginationEnabled="true"
          :navigationEnabled="true"
          :loop="true"
          :perPage="1"
        >
          <Slide v-for="(foto, index) in dados.fotos" :key="index">
            <img
              :src="foto.nm_path_completo"
              :alt="`Imagem ${index + 1}`"
              style="width: 100%; height: auto; border-radius: 10px;"
            />
          </Slide>
        </CustomCarousel>
        <div v-else class="item-sem-foto">
          <img :src="`${leilao.s3_path}/layout/images/sem_foto.png`"
               alt="Lote sem foto">
        </div>
      </div>
      <div class="status"
           :class="[contexto === 'item' ? 'status-seguirleiloeiro' : '', getStatusColor(dados.statuslote)]">
        {{ dados.statuslote }}
      </div>

      <div class="icons" :class="contexto === 'item' ? 'icons-seguirleiloeiro' : ''">

        <!-- compartilhar - seguirleiloeiro -->
        <div v-if="contexto === 'item'" @click="showModal" class="share-lote">
          <i class="icon-share-link" :class="isNotebook ? 'text-responsive' : ''"></i>
          <span v-if="!isNotebook || isTablet || isMobile && contexto === 'item'">Compartilhar</span>
        </div>

        <div v-else @click="showModal" class="share-lote">
          <i class="icon-share-link"></i>
        </div>

        <!-- favoritar lote - seguirleiloeiro -->
        <div v-if="contexto === 'item'" @click="addFavorito($event)" class="lote-favorito">
          <i class="fa-regular fa-heart" :class="`${localIsFavorito ? 'icon-heart-o' : 'icon-heart'}`"></i>
          <span v-if="!isNotebook || isTablet || isMobile && contexto === 'item'">{{
              localIsFavorito ? 'Desfavoritar' : 'Favoritar'
            }}</span>
        </div>

        <div v-else @click="addFavorito($event)" class="lote-favorito">
          <i class="fa-regular fa-heart" :class="`${dados.is_favorito ? 'icon-heart-o' : 'icon-heart'}`"></i>
        </div>

        <div v-if="statusleilao_id !== 17" class="lote-num"
             :class="contexto === 'item' ? 'lote-num-seguirleiloeiro' : ''">
          <span v-if="contexto === 'item'">Lote: {{ dados.nu < 10 ? '0' + dados.nu : dados.nu }}</span>
          <span v-else>{{ dados.nu < 10 ? '0' + dados.nu : dados.nu }}</span>
        </div>
      </div>

      <div
        v-for="(vistoria, id) in dados.vistoria"
        :key="id"
        v-if="vistoria.usuariovistorialotexstatusliberacaoextra !== undefined"
        @click.prevent="liberacaoExtraMsg(vistoria.usuariovistorialotexstatusliberacaoextra)"
        class="habilitacao_especial"
      >
        <div class="habilitacao_especial_label">
          <span>Requer habilitação especial</span>
          <i class="icon-lock"></i>
        </div>
      </div>
      <div v-if="contexto !== 'item'">
        <carousel :dados="dados" :visualizacao="this.$parent.visualizacao" :contexto="contexto"/>
      </div>

      <div v-show="statusleilao_id !== 17" class="card_titulo">
        <div>
          <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.5684 6.29621C3.03507 5.73486 3.03507 4.82473 3.5684 4.26338L6.83247 0.827903C7.36582 0.266553 8.23054 0.266553 8.76389 0.827903L10.206 2.34575C10.7393 2.9071 10.7393 3.81723 10.206 4.37857L9.06157 5.5831L12.511 9.21362C12.7777 9.4943 12.7777 9.94932 12.511 10.23C12.2443 10.5107 11.8119 10.5107 11.5453 10.23L8.09587 6.59951L6.94192 7.81405C6.40858 8.3754 5.54386 8.3754 5.01052 7.81405L3.5684 6.29621ZM1.25046 12.1557H0.79522C0.41809 12.1557 0.112366 12.4775 0.112366 12.8744C0.112366 13.2713 0.41809 13.5931 0.79522 13.5931H7.62376C8.00089 13.5931 8.30662 13.2713 8.30662 12.8744C8.30662 12.4775 8.00089 12.1557 7.62376 12.1557H7.16853V10.4787C7.16853 10.2141 6.96471 9.99953 6.71329 9.99953H1.70569C1.45428 9.99953 1.25046 10.2141 1.25046 10.4787V12.1557Z"
                  fill="#1C2D47"/>
          </svg>
        </div>
        <a class="card-titulo-lote" :href="`/leilao/index/leilao_id/${dados.leilao_id}/lote/${dados.lote_id}`">
          <h2 :title="dados.nm_titulo">{{ dados.nm_titulo }}</h2>
        </a>
      </div>
      <a :href="`/leilao/index/leilao_id/${dados.leilao_id}/lote/${dados.lote_id}`" class="card_content-body">
        <div v-for="(local, index) in lotesLocalizacao" v-if="local && local.estado && local.cidade" :key="index"
             class="info-local-lote">
          <div>
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.00002 0C9.62518 0 11.8127 2.02831 11.8127 4.46235C11.8127 5.25675 11.5182 6.04019 11.1067 6.75001C10.6935 7.46259 10.1465 8.12793 9.60316 8.69437C9.05873 9.26192 8.50864 9.73975 8.08004 10.0773C7.86597 10.246 7.67859 10.3824 7.53412 10.4791C7.46278 10.5268 7.39594 10.5688 7.33824 10.6009C7.31016 10.6165 7.27595 10.6345 7.23956 10.6501C7.22144 10.6578 7.19538 10.6682 7.16429 10.6774C7.13984 10.6847 7.07871 10.7016 7.00002 10.7016C6.92064 10.7016 6.85903 10.6844 6.8345 10.677C6.80324 10.6677 6.77709 10.6572 6.75894 10.6494C6.72248 10.6336 6.68824 10.6155 6.66017 10.5997C6.60249 10.5673 6.53567 10.525 6.46438 10.4769C6.32001 10.3796 6.13271 10.2421 5.91874 10.0724C5.49036 9.73278 4.94052 9.25248 4.39636 8.68341C3.85328 8.11548 3.30661 7.44954 2.89356 6.73862C2.48228 6.03075 2.18729 5.25052 2.18729 4.46235C2.18729 2.02831 4.37486 0 7.00002 0ZM7.00002 5.79505C6.20619 5.79505 5.56267 5.19838 5.56267 4.46235C5.56267 3.72632 6.20619 3.12965 7.00002 3.12965C7.79385 3.12965 8.43737 3.72632 8.43737 4.46235C8.43737 5.19838 7.79385 5.79505 7.00002 5.79505ZM10.1035 9.43066C10.2882 9.23808 10.4731 9.03633 10.6545 8.82672H11.0768H11.9995C12.1998 8.82672 12.3808 8.9374 12.4597 9.10809L13.9595 12.3529C14.0258 12.4964 14.01 12.6611 13.9173 12.7914C13.8247 12.9216 13.6676 13 13.4994 13H0.500692C0.332389 13 0.175344 12.9216 0.0826951 12.7914C-0.00995446 12.6611 -0.025813 12.4964 0.0404853 12.3529L1.54032 9.10809C1.61922 8.9374 1.80024 8.82672 2.00054 8.82672H2.92314H3.35774C3.53506 9.03143 3.71555 9.22873 3.89589 9.41729C4.55834 10.1101 5.22781 10.695 5.749 11.1081C6.00937 11.3146 6.23635 11.4811 6.41018 11.5983C6.4962 11.6563 6.57519 11.7063 6.64204 11.7438C6.6747 11.7622 6.71278 11.7822 6.75226 11.7993C6.77193 11.8078 6.7994 11.8188 6.83175 11.8284C6.8574 11.8362 6.9199 11.8536 6.99996 11.8536C7.07934 11.8536 7.14137 11.8364 7.16692 11.8289C7.19913 11.8193 7.2265 11.8085 7.24612 11.8C7.28555 11.7831 7.32359 11.7633 7.35626 11.7451C7.42313 11.7078 7.50214 11.6583 7.58821 11.6007C7.76214 11.4844 7.98921 11.3191 8.24969 11.1139C8.77108 10.7032 9.44082 10.1214 10.1035 9.43066Z"
                    fill="#7A7A7A"/>
            </svg>
          </div>
          <span class="local-lote">{{ local.cidade }}/{{ local.estado }}</span>
        </div>

        <div class="info">
          <span><i class="icon-info" :class="classCurrentBid"></i>Avaliação:</span>
          <span class="valor-avaliacao" :class="classCurrentBid">R$
            {{
              parseFloat(dados.vl_lanceminimo).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            }}
          </span>
        </div>

        <div class="info">
          <span><i class="icon-dollar" :class="classCurrentBid"></i>
          Lance {{ showLanceMinAtual ? 'mín. (Atual)' : 'mínimo' }}:
          </span>
          <span v-if="contexto === 'item'" class="lance-minimo" :class="classCurrentBid">R$
            {{
              parseFloat(dados.vl_lanceinicial).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            }}
          </span>
          <span v-else class="lance-minimo" :class="classCurrentBid">R$
            {{
              parseFloat(dados.vl_lanceinicial).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            }}
          </span>
        </div>

        <div class="info"
             v-if="showLanceMinAtual">
          <span><i class="icon-dollar" :class="classCurrentBid"></i>Lance mín. (Próx. data):</span>
          <span v-if="contexto === 'item'" class="lance-minimo" :class="classCurrentBid">R$
            {{
              parseFloat(dados.vistoria_vl_lanceinicialsegundoleilao).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
            }}
          </span>
          <span v-else class="lance-minimo" :class="classCurrentBid">
            {{ dados.vistoria_vl_lanceinicialsegundoleilao }}
          </span>
        </div>

        <div v-if="dados.vl_lance !== ''" class="info">
          <span class="current-bid">
            <i class="icon-dollar current-bid"></i>
            {{ statusleilao_id !== 17 ? 'Último lance:' : 'Desconto:' }}
          </span>
          <span class="current-bid-value">
            {{
              statusleilao_id !== 17 ? dados.vl_lance : `${dados.vl_lance.replace("R$ ", "").replace(",00", "").replace(".00", "")}%`
            }}
          </span>
        </div>
        <div class="info" v-if="dados.nm_usuario !== '-' && mainDomain !== 'meirelesleiloes'">
          <span class="current-bid">
            <i class="icon-user-circle current-bid"></i>
            Usuário:
          </span>
          <span class="current-bid">{{ dados.nm_usuario }}</span>
        </div>
        <div class="info" v-else-if="dados.nm_usuario !== '-' && mainDomain === 'meirelesleiloes'">
          <span class="user-name">{{ '@' + dados.nm_usuario }}</span>
        </div>
      </a>
    </div>
    <div class="card_footer">
      <!-- Botão de Lance Início -->
      <div v-if="showButtons" v-show="!loading">
        <div v-if="isLoteVendido || isLeilaoStatusVendido" class="tw-w-full tw-flex">
          <button
            :dataloteid="dados.lote_id"
            :datavalor="lanceValor"
            :disabled="true"
            :class="classeBotao"
          >
            <span>Enviar lance:</span>
            {{ lanceValor }}
          </button>
        </div>
        <div v-else class="tw-w-full tw-flex">
          <button
            @click="enviarLance"
            :dataloteid="dados.lote_id"
            :datavalor="lanceValor"
            :disabled="!lanceLiberado()"
            :class="classeBotao"
          >
            <span>Enviar lance:</span>
            {{ lanceValor }}
          </button>
        </div>
        <div v-if="loading" class="loading-overlay">
          <p>Enviando lance...</p>
        </div>
      </div>
      <!-- Botão de Lance Fim -->
      <Countdown
        :deadline="dt_fechamento_lote || ''"
        :statusleilao_id="statusleilao_id || 0"
        :statuslote_id="dados.statuslote || ''"
      >
      </Countdown>
    </div>
    <modal-share ref="modalShare"/>
  </div>
</template>

<script>
import Countdown from '@/components/shared/Countdown.vue'
import Carousel from '@/components/shared/Carousel.vue'
import CustomCarousel from '@/components/customCarousel/Carousel.vue'
import Slide from '@/components/customCarousel/Slide.vue'
// import { Carousel, Slide } from 'vue-carousel';
import {Circle6, Stretch} from 'vue-loading-spinner'
import ModalHAbilitacaoExtra from "./ModalHAbilitacaoExtra.vue";
import ModalShare from "./ModalShare.vue";
import {isValidBid} from '@/assets/js/utils.js';

export default {
  name: 'card_content',
  components: {
    ModalShare,
    ModalHAbilitacaoExtra,
    Countdown,
    Carousel,
    Stretch,
    Circle6,
    CustomCarousel,
    Slide
  },

  props: [
    'countLances',
    'leilao',
    'dados',
    'liberado',
    'usuarioid',
    'statusleilao_id',
    'intermediarios',
    'paramsite_proposta',
    'time',
    'dadosCondicao',
    'dados_condicao',
    'contexto',
    'destaqueLoteId'
  ],

  data() {
    return {
      errors: [],
      loading: false,
      pathName: location.protocol + '//' + window.HOSTNAME,
      widthCarousel: 235,
      vl_avaliacaocredito: '-',
      liberacaoStatus: false,
      dt_fechamento_lote: '',
      money: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
        min: 0,
        max: 100
      },
      is_favorito: false,
      localIsFavorito: this.dados.is_favorito,
      isUpdatingFavorito: false,
      shared: {
        nm_descricao: '',
        nm_titulo: '',
        leilao_id: null,
        lote_id: null,
      },
      screenWidth: window.innerWidth,
    }
  },

  watch: {
    dadosCondicao: {
      handler(novoValor) {
        if (novoValor) {
          this.lanceLiberado();
        }
      },
      deep: true,
    },
    $route(route) {
      this.refreshLote()
    },
    'dados.statuslote'(novo, ant) {
      if (novo !== ant) {
        (novo && novo === 'status') ? this.loading = true : this.loading = false
        this.refreshLote()
      }
    },
    'dados.vl_lance'(novo, ant) {
      if (novo !== ant) this.refreshLote()
    }
  },
  created() {
    this.refreshLote()
    const self = this


    this.firebase_db.ref(
      `/vl_avaliacaocredito/${self.dados.leilao_id}/${self.dados.lote_id}`
    ).on('value', function (vl_avaliacao_data) {
      var data = vl_avaliacao_data.val()
      if (data != undefined) {
        self.vl_avaliacaocredito = data.vl_credito
      }
    });
  },

  computed: {
    showButtons() {
      return this.statusleilao_id !== 13 && this.statusleilao_id !== 17;
    },
    isLoteVendido() {
      return this.dados.statuslote === 'Vendido';
    },
    isLeilaoStatusVendido() {
      return [1, 5, 8].includes(this.statusleilao_id);
    },
    lanceValorPrimeiroLeilao() {
      return !this.leilao.leilao_id_primeiroleilao ? this.dados.vl_lance_sugerido : false;
    },
    lanceValorSegundoLeilao() {
      return this.leilao.leilao_id_primeiroleilao ? this.dados.vl_lance_sugerido : false;
    },
    lanceValor() {
      return this.lanceValorPrimeiroLeilao || this.lanceValorSegundoLeilao;
    },
    classeBotao() {
      return this.lanceLiberado() ? 'bid-button' : 'bid-button-disable';
    },
    lotesLocalizacao() {
      if (!this.dados || !Array.isArray(this.dados.vistoria)) return [];

      return this.dados.vistoria.map((vistoria) => {
        let estado = '';
        let cidade = '';

        if (vistoria.i_nm_estado) {
          estado = vistoria.i_nm_estado;
          cidade = vistoria.i_nm_cidade || '';
        } else if (vistoria.v_nm_estado) {
          estado = vistoria.v_nm_estado;
          cidade = vistoria.v_nm_cidade || '';
        } else if (vistoria.e_nm_estado) {
          estado = vistoria.e_nm_estado;
          cidade = vistoria.e_nm_cidade || '';
        }

        return {estado, cidade};
      });
    },
    lanceMinimo() {
      if (this.leilao.leilao_id_primeiroleilao === null && this.leilao.datas < 1) {
        return this.dados.vistoria_vl_lanceinicial;
      } else {
        if (!this.dados.vistoria_vl_lanceinicialsegundoleilao || isNaN(this.dados.vistoria_vl_lanceinicialsegundoleilao)) {
          return this.dados.vistoria_vl_lanceinicial;
        } else {
          return this.dados.vistoria_vl_lanceinicialsegundoleilao;
        }
      }
    },
    isNotebook() {
      return this.screenWidth <= 1024;
    },
    isTablet() {
      return this.screenWidth <= 768;
    },
    isMobile() {
      return this.screenWidth <= 435;
    },
    classCardContent() {
      return this.mainDomain === 'meirelesleiloes' ? 'card_content-meireles' : 'card_content';
    },
    classCurrentBid() {
      return this.mainDomain === 'meirelesleiloes' ? 'current-bid' : '';
    },
    mainDomain() {
      if (typeof window === 'undefined') return '';

      const domainParts = window.location.hostname.split('.');

      if ((domainParts[0] === 'dev' || domainParts[0] === 'teste') && domainParts[1] !== 'vue') {
        return domainParts[1];
      }
      if (domainParts[0] === 'dev' && domainParts[1] === 'vue') {
        return domainParts[2];
      }
      if (domainParts[0] === 'www') {
        return domainParts[1];
      }

      return domainParts[0];
    },
    isDestaque() {
      return this.destaqueLoteId === this.dados.lote_id;
    },
    showLanceMinAtual() {
      if (this.dados) {
        return isValidBid(this.dados.vistoria_vl_lanceinicialsegundoleilao, this.dados.vistoria_vl_lanceinicial);
      }

      return false;
    }
  },

  methods: {
    lanceLiberado() {
      const usuarioLogado = !!this.usuarioid;
      const aceitouCondicoes = this.dadosCondicao && this.dadosCondicao.aceitou_condicao;
      const statusLotePermitido = this.dados && this.dados.statuslote ? ["Aberto para Lance", "Em Pregão", "Repasse", "Dou-lhe Uma", "Dou-lhe Duas"].includes(this.dados.statuslote) : false;
      const statusLeilaoPermitido = this.leilao && this.leilao.statusmontagem_id === 3;

      return usuarioLogado && aceitouCondicoes && statusLotePermitido && statusLeilaoPermitido;
    },
    refreshLote() {
      var db = this.firebase_db;
      var self = this;

      db.ref(`/dtfechamento/${self.dados.leilao_id}/${self.dados.lote_id}`)
        .on("value", function (data) {
            if (data.val()) {
              self.fechamento = data.val();
              self.dt_fechamento_lote = self.fechamento.dt_fechamento;
            }
          }
        );
    },

    formatarTitulo(titulo) {
      const limite = 57;

      if (titulo.length > limite) {
        return titulo.slice(0, limite) + '...';
      }
      return titulo;
    },

    closeTagsHtml(html) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;

      return tempElement.textContent || tempElement.innerText;
    },

    showModal() {
      const descricaoLimpa = this.dados.nm_descricao.replace(/<[^>]*>/g, '');
      const modalData = {
        header: "Compartilhe este lote em suas redes",
        title: this.dados.nm_titulo,
        description: descricaoLimpa,
        url: `${window.location.origin}/leilao/index/leilao_id/${this.dados.leilao_id}/lote/${this.dados.lote_id}`,
      };

      this.$refs.modalShare.modalToggle(modalData);
    },

    liberacaoExtraMsg(descricao) {
      this.$parent.modalHabilitacao(descricao)
    },

    isNumber(evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    addFavorito(event) {
      if (this.isUpdatingFavorito) return;

      this.isUpdatingFavorito = true;
      event.stopPropagation();

      const hostName = location.protocol + '//' + window.HOSTNAME;

      if (this.usuarioid) {
        let urlRequest = this.localIsFavorito ? 'exclui-favorito' : 'add-favorito';

        fetch(`${hostName}/leilao/${urlRequest}?lote_id=${this.dados.lote_id}&usuario_id=${this.usuarioid}`)
          .then(response => response.json())
          .then((data) => {
            if (data.is_favorito !== undefined) {
              this.localIsFavorito = data.is_favorito;

              this.$toast.open({
                message: data.msg,
                type: 'success',
              });
            }
            this.isUpdatingFavorito = false;
          })
          .catch((error) => {
            console.error(error);
            this.isUpdatingFavorito = false;

            this.$toast.open({
              message: 'Ocorreu um erro ao processar seu pedido.',
              type: 'error',
            });
          });
      } else {
        this.$toast.open({
          message: 'Você precisa estar logado para marcar como favorito!',
          type: 'error',
        });
      }
    },

    enviarLance(ev, pl) {
      if (!this.dados.liberado || !!!this.usuarioid) {
        this.$toast.open({
          message: 'Você precisa estar logado pra dar lances!',
          type: 'warning',
          duration: 4000,
          position: 'top-right',
        });
        return false;
      }

      var is_lance = true;

      const elem = ev.currentTarget;
      if (elem.getAttribute("disabled") === "true" || elem.getAttribute("disabled") === "disabled") {
        return false;
      }

      var valor = 0;
      const loteId = elem.getAttribute('dataloteid');

      if (this.dados.statuslote === 'Dou-lhe Duas') {
        this.$toast.open({
          message: 'Tempo de envio de lance esgotado.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
        return false;
      }

      var titulo = 'Lote';
      if (elem.getAttribute('datavalor') == 0) {
        valor = document.querySelector('#enviar_lance_manual_val_' + loteId).value;
        var nm_valor = valor + ' % de desconto';
        valor = valor.replace(/\./g, '').replace('R$ ', '').replace(',', '.');
        if (valor > 100) {
          self.$toast.open({
            message: 'Valor maior que o permitido de 100%',
            type: 'error',
            duration: 4000,
            position: 'top-right',
          });
          return false;
        }
        titulo = 'Rodada';
      } else {
        var nm_valor = elem.getAttribute('datavalor');
        valor = elem.getAttribute('datavalor').replace(/\./g, '').replace('R$ ', '').replace(',', '.');
      }

      const self = this;

      this.firebase_db.ref(`/lance/${self.dados.leilao_id}/${loteId}`)
        .orderByChild('id')
        .limitToLast(1)
        .once('value')
        .then(function (data) {
          if (data.val()) {
            // console.log(data);
            var usuario_id_ultimolance = Object.values(data.val())[0].nm_usuario_id;
          } else {
            var usuario_id_ultimolance = null;
          }

          var nm_intermediado = null;
          var usuario_id_logado = null;
          var usuario_id_intermediado = null;

          if (self.intermediarios != null) {
            nm_intermediado = document.querySelector('#cmb_usuario_intermediario_' + loteId).selectedOptions[0].text;
            usuario_id_intermediado = document.querySelector('#cmb_usuario_intermediario_' + loteId).value;
            usuario_id_logado = usuario_id_intermediado;
          } else {
            usuario_id_logado = self.usuarioid;
          }

          if (usuario_id_logado == usuario_id_ultimolance) {
            eventParcelamento();
            var elemParcelas = (!pl) ? parcelamento(self) : ''

            const percentEntrada = self.dados.nu_limitepercentuallote;

            const condicoesPagamento = `
            <div style="background-color: #f5f5f5; padding: 15px; border-radius: 10px; margin: 10px 0; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
              <span style="color: #512925; font-size: 16px; font-weight: 600;">Condições de pagamento:</span><br>
              ${self.dados.bn_aceitelanceparceladolote
              ? `
                ${percentEntrada > 0 ? `<p style="margin: 5px 0;"><strong>Entrada: ${percentEntrada}%</strong></p>` : ''}
                <p style="margin: 5px 0;"><strong>${pl > 1 ? `Parcelamento: ${pl}x` : `Pagamento: à vista ou parcelado em até ${self.dados.nu_limiteparcelaslote}x`}</strong></p>
                ${elemParcelas}
              `
              : `
                <p style="margin: 5px 0;"><strong>Pagamento: à vista</strong></p>
              `}
            </div>`;

            self.$modal.show('dialog', {
              title: `<strong style="font-size:20px;color: #512925;">` + titulo + ` ${self.dados.nu}</strong>`,
              text: ` <p style="color: red;"><strong>VOCÊ JÁ TEM O MAIOR LANCE DESTE LOTE, DESEJA COBRIR O PRÓPRIO LANCE?</strong></p>
                            <p>${self.dados.nm_titulo}</p>
                            ${condicoesPagamento}
                            <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${nm_valor}</strong> </p>`,
              buttons: [
                {
                  title: 'NÃO',
                  handler: () => {
                    self.loading = false;
                    self.$modal.hide('dialog');
                  }
                },
                {
                  title: 'SIM',
                  default: true, // HABILITAR BOTÃO ENTER
                  handler: () => {
                    self.$modal.hide('dialog');
                    var parcela = 1;
                    var parcelaElemento = document.querySelector('#limite_parcelas option:checked');

                    if (parcelaElemento) {
                      parcela = parcelaElemento.value;
                    }
                    modalEnviaLance(
                      self,
                      loteId,
                      valor,
                      nm_valor,
                      is_lance,
                      titulo,
                      usuario_id_intermediado,
                      nm_intermediado,
                      parcela
                    );
                  }
                }
              ]
            });
          } else {
            modalEnviaLance(
              self,
              loteId,
              valor,
              nm_valor,
              is_lance,
              titulo,
              usuario_id_intermediado,
              nm_intermediado,
              null
            );
          }
        });
    },

    loteClicado() {
      this.$parent.$emit('loteIdAtualChange', this.dados.lote_id);
    },

    formatStatusCredito(statuslote) {
      var nm_statuslote = '';
      switch (statuslote) {
        case 'Aberto para Lances':
          nm_statuslote = 'Aguarde';
          break;
        case 'Vendido':
        case 'Não Vendido':
          nm_statuslote = 'Encerrado';
          // expected output: "Mangoes and papayas are $2.79 a pound."
          break;
        default:
          nm_statuslote = statuslote;
      }
      return nm_statuslote;
    },

    getStatusColor(status) {
      switch (status) {
        case "Aberto para Lance"    :
          return "tw-bg-jrGreen-new";
        case "Em Pregão"            :
          return "tw-bg-jrGreen-200";
        case "Dou-lhe Duas"         :
          return "tw-text-white tw-bg-jrRed-new";
        case "Aguardando"           :
          return "tw-text-white tw-bg-jrGray-200";
        case "Vendido"              :
          return "tw-text-white tw-bg-jrWater-100";
        case "Condicional"          :
          return "tw-text-white tw-bg-jrGray-300";
        case "Repasse"              :
          return "tw-text-white tw-bg-jrGray-300";
        case "Não Vendido"          :
          return "tw-text-white tw-bg-jrRed-100";
        case "Não Homologado"       :
          return "tw-bg-jrGray-100";
        case "Sub Judice"           :
          return "tw-text-white tw-bg-jrGray-200";
        case "Homologado"           :
          return "tw-text-white tw-bg-jrBlue-100";
        case "Retirado"             :
          return "tw-text-white tw-bg-jrRed-100";
        case "Repasse com Lance"    :
          return "tw-text-white tw-bg-jrBlue-100";
        case "Dou-lhe Uma"          :
          return "tw-bg-jrOrange-new";
        case "Cancelado"            :
          return "tw-text-white tw-bg-jrRed-100";
        case "Fechado"              :
          return "tw-text-white tw-bg-jrGray-200";
        case "Arrematado Não Pago":
          return "tw-bg-jrBlue-new tw-text-white tw-font-bold";
        case "Adiado":
          return "tw-text-white tw-bg-jrRed-100";
        case "Dou-lhe Três"         :
          return "tw-bg-white";
        case "Excluido"             :
          return "tw-text-white tw-bg-jrRed-100";
        case "Arrematado Sub Judice":
          return "tw-text-white tw-bg-jrBlue-200";
      }
    },
  }
}

function parcelamento(self) {
  var parcelamento = self.$root.refreshParcelamento(self.dados);
  var elemParcelas = `<label style="${(!self.dados.nu_limiteparcelaslote) ? 'display: none;' : ''}"> Parcelas`;

  elemParcelas += `<select id="limite_parcelas" onchange="window.eventParcelas()" style="width: fit-content; margin-left: 5px">`;

  if (self.dados.nu_limiteparcelaslote) {
    for (let index = 1; index <= parcelamento; index++) {
      var text = (index === 1) ? 'à vista' : `${index}x`;
      elemParcelas += `<option value="${index}" ${(index == 1) ? 'selected' : ''}>${text}</option>`;
    }
  } else {
    elemParcelas += `<option value="1" selected>à vista</option>`;
  }

  elemParcelas += `</select></label>`;

  return elemParcelas;
}

function eventParcelamento() {
  window.eventParcelas = () => {
    var parcelaSelecionada = document.querySelector('#limite_parcelas option:checked')

    if (parcelaSelecionada) {
      var limite_parcelas = parcelaSelecionada.value
      var elem = document.querySelector('#limite_parcelas_porcentagem')

      if (limite_parcelas > '1' && elem) {
        elem.style.display = 'block'
      } else if (elem) {
        elem.style.display = 'none'
      }
    }
  }
}

function modalEnviaLance(
  self,
  loteId,
  valor,
  nm_valor,
  is_lance,
  titulo,
  usuario_id_intermediado,
  nm_intermediado,
  pl
) {
  var nm_descricao = '<p>Confirmar o envio de lance?</p>'

  if (is_lance == false) {
    nm_descricao = '<p>Confirmar a venda direta ?</p>'
  }

  if (usuario_id_intermediado != null) {
    nm_descricao =
      `<p>Confirmar o envio de lance para o usuário <b style="color: red;">` +
      nm_intermediado +
      ` </b>?</p>`
  }

  eventParcelamento()
  var elemParcelas = (!pl) ? parcelamento(self) : '';
  const percentEntrada = self.dados.nu_limitepercentuallote;

  const condicoesPagamento = `
  <div style="background-color: #f5f5f5; padding: 15px; border-radius: 10px; margin: 10px 0; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);">
    <span style="color: #512925; font-size: 16px; font-weight: 600;">Condições de pagamento:</span><br>
    ${self.dados.bn_aceitelanceparceladolote
    ? `
      ${percentEntrada > 0 ? `<p style="margin: 5px 0;"><strong>Entrada: ${percentEntrada}%</strong></p>` : ''}
      <p style="margin: 5px 0;"><strong>${pl > 1 ? `Parcelamento: ${pl}x` : `Pagamento: à vista ou parcelado em até ${self.dados.nu_limiteparcelaslote}x`}</strong></p>
      ${elemParcelas}
    `
    : `
      <p style="margin: 5px 0;"><strong>Pagamento: à vista</strong></p>
    `}
  </div>`;

  // Ja existente
  self.$modal.show('dialog', {
    title: `<strong style="font-size:20px;color: #512925;">` + titulo + ` ${self.dados.nu}</strong>`,
    text: `<p style="color: #512925;"><strong>${self.dados.nm_titulo}</strong></p>
          ${condicoesPagamento}
          <p> valor: <strong style="font-weight:800 !important; font-size:30px;color: #3b8119;"> ${nm_valor}</strong> </p>`,
    buttons: [
      {
        title: 'Cancelar',
        handler: () => {
          self.loading = false
          self.$modal.hide('dialog')
        }
      },
      {
        title: 'Enviar',
        default: true, // HABILITAR BOTÃO ENTER
        handler: () => {
          self.loading = true
          var elemParcelas = document.querySelector('#limite_parcelas');
          var parcelas = (!pl) ? (elemParcelas ? elemParcelas.value : 1) : pl;
          var urlParcelas = (parcelas > 1) ? '&nu_parcelas=' + parcelas : '&nu_parcelas=' + 1

          var url_post = `${self.pathName}/leilao/envialance/?ajax=1&leilao_id=${self.dados.leilao_id}&lote_id=${loteId}&vl_lance=${valor}&force=0${urlParcelas}&firebase=1`
          if (usuario_id_intermediado != null) {
            url_post =
              url_post + '&usuario_id_intermediado=' + usuario_id_intermediado
          }

          fetch(url_post, {method: 'POST'})
            .then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
              }
              return res.json();
            })
            .then(res => {
              if (res.erro == true) {
                self.errors.push(res)
                self.$toast.open({
                  message: self.$root.decodeHtml(res.msg_erro),
                  type: 'error',
                  duration: 4000,
                  position: 'top-right',
                });
              }
              // Tracking google analytics envio de lance
              ga('send', 'event', 'lance', 'enviado')

              // FECHA MODAL E PARA O LOADING
              self.loading = false
              self.$modal.hide('dialog')
            })
            .catch(e => {
              self.errors.push(e)
              self.loading = false
              self.$modal.hide('dialog')
            })
        }
      }
    ]
  })
}
</script>
<style scoped>
.card_content {
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/card-lote.png");
  background-repeat: no-repeat;
  border-radius: 10px;
  overflow: hidden;
  min-height: 453px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card_content-meireles {
  background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/card-lote.png");
  background-repeat: no-repeat;
  border-radius: 10px;
  overflow: hidden;
  min-height: 470px;
  width: 280px !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-position: center;
  background-size: cover;
}

.card_content.destaque {
  animation: swap-bg 2s infinite alternate;
}

.card_content-meireles.destaque {
  animation: swap-bg-meireles 2s infinite alternate;
}

@keyframes swap-bg {
  0%, 100% {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/card-lote.png");
  }
  50% {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/card-lote-destaque.png");
  }
}

@keyframes swap-bg-meireles {
  0%, 100% {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/card-lote.png");
  }
  50% {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/highlight-animation.png");
  }
}

.card_content-seguirleiloeiro {
  width: 26%;
}

@media (max-width: 768px) {
  .card_content-seguirleiloeiro {
    width: 50%;
    min-height: 695px !important;
    max-height: 695px !important;
  }
}

@media (max-width: 435px) {
  .card_content-seguirleiloeiro {
    width: 100% !important;
    min-height: 695px !important;
    max-height: 695px !important;
  }

  .card_content-header-seguirleiloeiro {
    gap: 10px !important;
  }

  .card_content {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/card-lote-435.png");
  }

  .card_content-meireles {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/card-lote-435.png");
  }

  .card-titulo-lote {
    max-width: 307px !important;
  }

  @keyframes swap-bg-meireles {
    0%, 100% {
      background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/card-lote-435.png");
    }
    50% {
      background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/highlight-animation-435.png");
    }
  }
}

@media (max-width: 375px) {
  .card_content {
    background-image: url("https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/jrleiloes/layout/images/card-lote.png");
  }
}

.card_content-header {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.card-header img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 15px;
  cursor: pointer;
}

.card_content-header .status {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  z-index: 99;
}

.card_content-body {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
}

.card_titulo {
  position: relative;
  padding: 0 10px 0 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  height: 42px;
}

.card_titulo .card-titulo-lote {
  font-size: 14px;
  color: #1C2D47;
  cursor: pointer;
  font-weight: bold;
}

.card-titulo-lote {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 227px;
}

.info {
  display: flex;
  justify-content: space-between;
}

.info-local-lote {
  gap: 10px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666
}

.info span {
  font-size: 11px;
  color: #666;
  display: flex;
  align-items: center;
}

.local-lote {
  font-weight: 700;
}

.info i {
  font-size: 16px;
  margin-right: 10px;
  color: #7A7A7A;
}

.icons {
  position: absolute;
  top: 10px;
  right: 10px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  z-index: 99;
}

.share-lote,
.lote-favorito {
  padding: 6px 10px;
  background-color: #7A7A7A;
  font-size: 12px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lote-num {
  background-color: #6aba62;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 5px;
  color: #fff;
  z-index: 99;
  position: absolute;
  top: 130px;
  right: 0;
  font-weight: 700;
}

.card_content-seguirleiloeiro {
  display: flex;
  justify-content: space-between;
  border-radius: initial;
  max-height: 377px;
  min-height: 377px;
}

.card_content-seguirleiloeiro .card_content-header-seguirleiloeiro .card_titulo,
.card_content-seguirleiloeiro .card_content-header-seguirleiloeiro .card_content-body,
.card_content-seguirleiloeiro .card_footer {
  padding: initial;
}

.card_content-seguirleiloeiro .card_content-header-seguirleiloeiro .card_titulo {
  margin-top: 10px;
}

.card_content-seguirleiloeiro .card_content-header-seguirleiloeiro .card_titulo .card-titulo-lote {
  max-width: 379px;
}

.card_content-seguirleiloeiro .card_content-header-seguirleiloeiro .status {
  margin-bottom: 15px;
  text-align: center;
}

.card_content-seguirleiloeiro .card_content-header-seguirleiloeiro .card_content-body {
  gap: 10px;
}

.status-seguirleiloeiro {
  position: relative !important;
  top: initial !important;
  left: initial !important;
}

.icons-seguirleiloeiro {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  top: 0;
  right: 0;
}

.icons-seguirleiloeiro .share-lote,
.icons-seguirleiloeiro .lote-favorito {
  display: flex;
  align-items: center;
  gap: 10px;
  transition: opacity 0.3s ease;
}

.icons-seguirleiloeiro .share-lote:hover,
.icons-seguirleiloeiro .lote-favorito:hover {
  opacity: 0.8;
}

.icons-seguirleiloeiro .lote-num {
  top: 0;
  left: 0;
  width: fit-content;
  padding: 6px 10px;
}

.item-sem-foto img {
  border-radius: 10px;
}

.lote-num span {
  width: max-content;
  display: flex;
}

.current-bid {
  color: #1C2D47 !important;
  font-weight: 500;
  font-size: 16px;
}

.user-name {
  font-weight: 500;
  transform: translate(20px, -5px);
}

.current-bid-value {
  color: #1C2D47 !important;
  font-weight: 700;
  text-decoration: underline;
}

.card_footer {
  padding: 10px;
}

.bid-button {
  padding: 10px;
  text-align: center;
  font-size: 12px;
  display: flex;
  justify-content: center;
  gap: 5px;
  border-radius: 5px;
  width: 100%;
  background-color: #6ABA62;
  color: #fff;
  font-weight: 700;
  transition: background-color 0.3s ease;
}

.bid-button:hover {
  background-color: #407E3A;
  transition: background-color 0.3s ease;
}

.bid-button span {
  color: #407E3A;
  font-weight: 700;
  transition: background-color 0.3s ease;
}

.bid-button:hover span {
  color: #6aba62;
  transition: background-color 0.3s ease;
}

.lance-minimo,
.valor-avaliacao {
  font-weight: 700;
}

.bid-button-disable {
  padding: 10px;
  width: 100%;
  border-radius: 5px;
  color: #fff;
  background-color: #6ABA62;
  font-weight: 700;
  font-size: 12px;
  cursor: not-allowed;
}

.bid-button-disable span {
  color: #407E3A;
  font-weight: 700;
}

.habilitacao_especial {
  display: flex;
  position: absolute;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  margin-top: 9.7rem;
  color: #3f3f3f;
  background: #e6e6e6bd;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  transition: 0.3s ease;
  animation: efeitoTransitionHabilitacao;
  z-index: 99;
}

.habilitacao_especial:hover {
  transition: 0.3s ease;
  height: 176px;
  flex-direction: column;
  margin-top: 0;
  font-size: 18px;
}

@keyframes efeitoTransitionHabilitacao {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 20px;
  z-index: 9999;
}

.error-message {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Card.vue